<template>
<div class="container-fluid">
    <div class="panel panel-info">
  <!-- <div class="col-md-12" style="border: 1px solid black">
    <h4>Add Vaccination Details
        <div class="col-md-6">
            <right>
                <b-button variant="success" @click="show_add_modal">Add </b-button>
            </right>
        </div> -->
        
         <div class="p-3 mb-2 col-12">
        <h4 style="text-align: left">Add Insurance Details
            <b-button variant="success" @click="show_add_modal">Add</b-button>
        </h4>
        
          
        
      </div>
        </div>
   
    <hr/>
    <b-form @submit.stop.prevent>
       
        
        <div class="col-md-12">
            <b-table-simple responsive>
                <b-thead>
                    <b-tr>
                    <b-th>Tag No</b-th>
                    <b-th>Insurance Type</b-th>
                    <!-- <b-th>Insurance Name</b-th> -->
                    <b-th>From Date</b-th>
                    <b-th>To Date</b-th>
                    
                    
                    </b-tr>
                </b-thead>
                <b-tbody v-for="(item,index) in selected_animal_details" :key="index">
                    <b-tr>
                    <b-td>{{item.tag}}</b-td>
                    <b-td>{{item.type1}}</b-td>
                    <b-td>{{item.type2}}</b-td>
                   
                    <b-td>{{item.certificate}}</b-td>
                    <b-td>{{item.breed}}</b-td>
                    <b-td>{{item.age}}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
        <div class="col-md-12">
            <center>
                
                <b-button variant="primary" @click="handleSubmit">Submit</b-button>&nbsp;
                <b-button variant="danger" @click="handleBack">
                    <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
                </b-button>
            </center>
        </div><br/>
   </b-form>
   <div>
    <b-modal id="modal-1" ref="add-modal" title="Add Insurance Details" hide-footer="true" ok-variant="hidden" cancel-variant="hidden">
        <b-form @submit.stop.prevent>
            <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Tag No</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-input-group >
                        <template #append>
                            <b-input-group-text @click="handleSearch">
                                <b-icon-search></b-icon-search>
                            </b-input-group-text>
                        </template>
                        <b-form-input v-model="tag"></b-form-input>      
                    </b-input-group>
                    <!-- <b-form-input id="input-small" size="sm" v-model="tag" placeholder=""></b-form-input> -->
                </div>
            </div>
            <!-- <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Insurance Type</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="type1" placeholder=""></b-form-input>
                </div>
            </div> -->
            <!-- <div class="col-sm-3"> -->
                <div class="form-group row">
                 <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label ">Insurance Type</label>
                     <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    
                         <!-- <b-form-input id="input-small" size="sm" v-model="type1" placeholder=""></b-form-input> -->
                      <select class="form-control">
                        <option value="" >Select</option>
                        <option value="Primary">Primary</option>
                        <option value="Booster">Booster</option>
                        <option value="Revaccination">Revaccination</option>
                      
                        
                      </select>
                    </div>
                </div>
            <!-- <div class="dropdown">
  <button class="dropbtn">Dropdown</button>
  <div class="dropdown-content">
    <a href="#">Link 1</a>
    <a href="#">Link 2</a>
    <a href="#">Link 3</a>
  </div>
</div> -->
             <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Insurance Name</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="type2" placeholder=""></b-form-input>
                </div>
            </div>
             
           
            
            <div class="form-group row">
            <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">From Date</label>
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
            <div>
                <!-- <input type="date" id="input-small" v-model="date"> -->
            <b-form-datepicker id="datepicker-placeholder" placeholder="Choose a date" locale="en"></b-form-datepicker>
             </div>   <!-- <b-form-input id="input-small" v-model="date" size="sm" placeholder=""></b-form-input> -->
            </div>
        </div>
        <div class="form-group row">
            <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">To Date</label>
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
            <div>
                <!-- <input type="date" id="input-small" v-model="date"> -->
            <b-form-datepicker id="datepicker-placeholder" placeholder="Choose a date" locale="en"></b-form-datepicker>
             </div>   <!-- <b-form-input id="input-small" v-model="date" size="sm" placeholder=""></b-form-input> -->
            </div>
        </div>
            <!-- <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Is Calf Available ?</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="calf" placeholder=""></b-form-input>
                </div>
            </div> -->
            <!-- <div class="form-group row">
                <label for="staticEmail" class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label">Age</label>
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <b-form-input id="input-small" size="sm" v-model="age" placeholder=""></b-form-input>
                </div>
            </div> -->
            <div class="col-md-12">
                <!-- <center>
                    <b-button v-b-modal.modal-sm variant="primary">View Medical Certificate</b-button>
                </center> -->
            </div>
            <b-modal id="modal-sm" size="sm" title="Medical Certificate">insurance Certificate Will go Here...</b-modal>
            <hr/>
            <div class="col-md-12">
                <center>
                    <b-button variant="success" @click="handleAdd">Add</b-button>
                </center>
            </div>
        </b-form> 
    </b-modal>
    </div>
</div>
    
    
</template>
<script>
export default {
  data() {
    return {
      name: "",
      certificate_no: "",
      from: "",
      to: "",
      date: "",
      vehicle: "",
      vehicle_type: "",
      driver_name: "",
      tag: "",
      type1: "",
      type2: "",
      type3: "",
      type4: "",
      type5: "",
      breed: "",
      calf: "",
      age: "",
      selected_animal_details: [],
    };
  },
  methods: {
    handleSearch() {
      alert("Search");
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleSubmit() {
      var data = {
        name: this.name,
        certificate: this.certificate_no,
        from: this.from,
        to: this.to,
        date: this.date,
        vehicle: this.vehicle,
        vehicle_type: this.vehicle_type,
        driver: this.driver_name,
        animal_data: this.selected_animal_details,
      };
      console.log(data);
      this.reset_data();
      alert("Data Submitted Successfully");
    },
    reset_data() {
      this.name = "";
      this.certificate_no = "";
      this.from = "";
      this.to = "";
      this.date = "";
      this.vehicle = "";
      this.vehicle_type = "";
      this.driver_name = "";
      this.selected_animal_details = "";
    },
    modal_reset() {
      this.tag = "";
      this.breed = "";
      this.type = "";
      this.calf = "";
      this.age = "";
    },
    show_add_modal() {
      this.$refs["add-modal"].show();
    },
    handleAdd() {
      let selected_animal_details = {
        index: this.selected_animal_details.length + 1,
        tag: this.tag,
        Vaccine_Type: this.type1,
        type2: this.type2,
        type3: this.type3,
        type4: this.type4,
        type5: this.type5,
        breed: this.breed,
        calf: this.calf,
        age: this.age,
      };
      this.selected_animal_details.push(selected_animal_details);
      console.log(this.selected_animal_details);
      this.modal_reset();
      this.$refs["add-modal"].hide();
    },
  },

};
 
</script>
